__turbopack_context__.v({
  "app-store-reviews": "M1Reviews-module__JtqVVW__app-store-reviews",
  "appStoreReviews": "M1Reviews-module__JtqVVW__appStoreReviews",
  "author": "M1Reviews-module__JtqVVW__author",
  "content": "M1Reviews-module__JtqVVW__content",
  "description": "M1Reviews-module__JtqVVW__description",
  "rating": "M1Reviews-module__JtqVVW__rating",
  "rating-wrapper": "M1Reviews-module__JtqVVW__rating-wrapper",
  "repeat-user": "M1Reviews-module__JtqVVW__repeat-user",
  "root": "M1Reviews-module__JtqVVW__root",
  "title": "M1Reviews-module__JtqVVW__title",
  "user-reviews": "M1Reviews-module__JtqVVW__user-reviews",
  "userReview": "M1Reviews-module__JtqVVW__userReview",
});
